import React, { useReducer, createContext, useContext } from "react";
export const GlobalContext = createContext();

const initialState = {
  loading: false,
  dadosusuario: [],
  tourclose: [],
  regraselecionada: [],
  menulateral: [],
  menuaberto: {},
  openmenu: false,
  ativomenu: "",
  pesquisa: [],
  confirmaplano: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_RESET":
      let resetState = JSON.parse(JSON.stringify(initialState));
      return resetState;
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_TOURCLOSE":
      return {
        ...state,
        tourclose: action.payload,
      };
    case "SET_USUARIO":
      return {
        ...state,
        dadosusuario: action.payload,
      };
    case "SET_REGRASELECIONADA":
      return {
        ...state,
        regraselecionada: action.payload,
      };
    case "SET_MENULATERAL":
      return {
        ...state,
        menulateral: action.payload,
      };
    case "SET_MENUABERTO":
      return {
        ...state,
        menuaberto: action.payload,
      };
    case "SET_OPENMENU":
      return {
        ...state,
        openmenu: action.payload,
      };
    case "SET_MENUATIVO":
      return {
        ...state,
        ativomenu: action.payload,
      };
    case "SET_PESQUISA":
      return {
        ...state,
        pesquisa: action.payload,
      };
    case "SET_CONFIRMAPLANO":
      return {
        ...state,
        confirmaplano: action.payload,
      };
    default:
      throw new Error();
  }
};

export const GlobalContextProvider = (props) => {
  const [state, dispatch] = useReducer(
    reducer,
    JSON.parse(JSON.stringify(initialState)),
  );

  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error(
      "useGlobalState deve ser usado dentro de um GlobalContextProvider",
    );
  }
  return context;
};

export default GlobalContext;
